<template>
  <div class="modalOutlet">
    <slotModal
      :id-modal="'modalOutlet'"
      :modal-title="'E-Pay ' + dataOutlet.name"
      :footer="false"
      v-model="modal"
      @close="close"
      class="titleModal"
    >
      <template v-slot:modal-content>
        <div
          class="modal-top d-flex flex-column justify-content-center align-items-start align-self-stretch p-3"
          style="background-color: #f2f5f7"
        >
          <p class="f-Overpass f-w-400 f-c-black f-14 my-0">
            E-Pay {{ dataOutlet.name }} dapat anda gunakan di outlet-outlet
            berikut
          </p>
        </div>
        <div
          class="d-flex p-16 flex-column align-items-start align-self-stretch m-3 gap-3"
        >
          <div
            class="cards-of-modal d-flex p-16 align items-center justify-content-between p-4 w-100"
          >
            <div class="its-texts">
              <p class="f-c-black f-16 f-w-600 my-0">
                {{ dataOutlet.name }}
              </p>
              <div class="d-flex mt-1">
                <img
                  src="../../../../assets/icons/location.svg"
                  alt="location"
                />
                <p class="f-12 f-w-400 f-c-grey my-0">
                  {{ dataOutlet.kota }}
                </p>
              </div>
            </div>

            <div class="f-16 f-w-400 f-c-blue d-flex align-items-center">
              <p class="m-0" @click="handleTextClick">Lihat Lokasi</p>
            </div>
          </div>
          <!-- <template v-for="(pilihOutlet, index) in dataUserEpay.customer">
            <template v-if="pilihOutlet.outlet !== null">
              <cardOutlet
                :namaOutlet="pilihOutlet.outlet.nama"
                :kotaOutlet="pilihOutlet.outlet.kota"
                :latitude="pilihOutlet.outlet.latitude"
                :longtitude="pilihOutlet.outlet.longitude"
                :key="index"
              />
            </template>
          </template> -->
        </div>
      </template>
    </slotModal>
  </div>
</template>

<script>
import slotModal from "@/components/slots/slotModal.vue";
// import cardOutlet from "../cardOutlet.vue";
import { mapState } from "vuex";

export default {
  name: "modalOutlet",
  components: {
    slotModal,
    // cardOutlet,
  },

  props: {
    nama: String,
    kota: String,
    latitudeOutlet: Number,
    longitudeOutlet: Number,
  },

  computed: {
    ...mapState("dashboard", {
      dataUserEpay: "dataUserEpay",
      dataOutlet: "dataOutlet",
    }),
  },

  data() {
    return {
      modal: false,
      dataModal: 0,
      namaOutlet: "",
      kotaOutlet: "",
      Latitudeoutlet: 0,
      Longitudeutlet: 0,
    };
  },

  methods: {
    open() {
      this.modal = true;
      // console.log(this.nama);
      // console.log(this.latitudeOutlet);
      // console.log(this.longitudeOutlet);
      this.$store.commit("dashboard/setDataOutlet", {
        name: this.nama,
        kota: this.kota,
        latitude: this.latitudeOutlet,
        longitude: this.longitudeOutlet,
      });
    },
    close() {
      this.modal = false;
    },
    handleTextClick() {
      const latitude = this.dataOutlet.latitude;
      const longitude = this.dataOutlet.longitude;
      const googleMapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;

      window.open(googleMapsUrl, "_blank");
    },
  },
};
</script>

<style scoped>
.cards-of-modal {
  gap: 16px;
  border-radius: 16px;
  border: 1px solid var(--surface-divider, #ededed);
  background: var(--primary-white, #fff);
  box-shadow: 0px 4px 12px 0px rgba(0, 34, 119, 0.06);
}
</style>
